import React from "react";
const IconToggleOn = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <rect x="7" y="4" width="12" height="12" rx="6" stroke="currentColor" strokeWidth="2" strokeLinejoin="bevel" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 4C3.68629 4 1 6.68629 1 10C1 13.3137 3.68629 16 7 16H13C9.68629 16 7 13.3137 7 10C7 6.68629 9.68629 4 13 4H7Z"
      fill="currentColor"
    />
    <path
      d="M2 10C2 7.23858 4.23858 5 7 5V3C3.13401 3 0 6.13401 0 10H2ZM7 15C4.23858 15 2 12.7614 2 10H0C0 13.866 3.13401 17 7 17V15ZM13 15H7V17H13V15ZM13 15C10.2386 15 8 12.7614 8 10H6C6 13.866 9.13401 17 13 17V15ZM8 10C8 7.23858 10.2386 5 13 5V3C9.13401 3 6 6.13401 6 10H8ZM7 5H13V3H7V5Z"
      fill="currentColor"
    />
  </svg>
);
export default IconToggleOn;
